import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { IvtfSupplementationActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface IvtfSupplementationActionFormGroup {
	rate: FormControl<UnitQuantity | null>;
	totalRate: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-ivtf-supplementation-action-controls-v2',
    templateUrl: './ivtf-supplementation-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './ivtf-supplementation-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvtfSupplementationActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: IvtfSupplementationActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as IvtfSupplementationActionV2;
	}

	@Input() form!: FormGroup<IvtfSupplementationActionFormGroup>;
	@Input() item!: Row;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
		this.form.addControl('totalRate', this.formBuilder.control(this.action?.totalRate ?? null));
	}
}